import { render } from "./MemberInfoDialog.vue?vue&type=template&id=638cfe43&scoped=true"
import script from "./MemberInfoDialog.vue?vue&type=script&lang=js"
export * from "./MemberInfoDialog.vue?vue&type=script&lang=js"

import "./MemberInfoDialog.vue?vue&type=style&index=0&id=638cfe43&lang=scss&scoped=true"

import exportComponent from "/Users/hou/Desktop/zijie/sdxlxh_user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-638cfe43"]])

export default __exports__